export enum PageType {
  Custom = "custom",
  ServicePage = "service_page",
  ServicePageWithDependencies = "service_page_with_dependencies",
  Discovery = "discovery",
  Releases = "releases_service_dependency",
  Disruption = "disruption",
  Help = "help",
  None = "*",
}
